import { render, staticRenderFns } from "./AddonsTrigger.vue?vue&type=template&id=e15b0104&scoped=true&"
import script from "./AddonsTrigger.vue?vue&type=script&lang=ts&"
export * from "./AddonsTrigger.vue?vue&type=script&lang=ts&"
import style0 from "./AddonsTrigger.vue?vue&type=style&index=0&id=e15b0104&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e15b0104",
  null
  
)

export default component.exports